import React from 'react'
import TPCheckbox from "../../../TemplateProperties/TPCheckbox";
import { useTranslation } from "react-i18next";

export default function DateDataValidation(props) {
    const { t } = useTranslation();

    return (
        <>
            <div>
                <TPCheckbox
                    label={t("BTN_BY_PASS_VALIDATION")}
                    handleCheck={
                        () => props.handleCheckbox("SHOULD_ALLOW_BY_PASS")
                    }
                    checked={props.SHOULD_ALLOW_BY_PASS}
                    inputProps={{ type: 'number' }} />
            </div>
        </>
    )
}
